import { identityNo, mail, phoneNo, password, name, dateOfBirth, address,RefAgent } from './rules';

function generateIdentityId() {
  const charNumRefer = 'ABCDEFGHJKLMNPQRSTUVXYWZIO'
    .split('')
    .reduce((acc, char, index) => {
      acc[char] = index + 10;
      return acc;
    }, {});
  const weights = [1, 9, 8, 7, 6, 5, 4, 3, 2, 1, 1];
  const firstCharNum = Math.floor(Math.random() * (35 - 10)) + 10;
  const splitFirstCharNum = Array.from(String(firstCharNum), Number);
  const genderNum = Math.floor(Math.random() * 2) + 1;
  const randomNumsArr = Array.from(
    { length: 7 }, () => Math.floor(Math.random() * 9) + 1
  );
  
  const total = [...splitFirstCharNum, genderNum, ...randomNumsArr]
    .reduce((acc, num, index) => {
      const val = acc + (num * weights[index]);
      return val;
    }, 0);
  const lastNum = total % 10 === 0 ? 0 : 10 - (total % 10);
  const firstChar = Object.keys(charNumRefer).find(key => charNumRefer[key] === firstCharNum);
  return `${firstChar}${genderNum}${randomNumsArr.join('')}${lastNum}`;
}

export const devModel = {
  name: {
    firstName: '林',
    lastName: '天天'
  },
  dateOfBirth: {
    year: '1991',
    month: '11',
    day: '22',
  },
  identityNo: generateIdentityId(),
  phoneNo: '0910123431',
  mail: 'cool@gg.cc',
  address: {
    city: '基隆市',
    area: '信義區',
    road: '八德路',
    zip: '201'
   },RefAgent:'ga5b333'
  // name: {
  //   firstName: '',
  //   lastName: ''
  // },
  // dateOfBirth: {
  //   year: '',
  //   month: '',
  //   day: '',
  // },
  // identityNo: '',
  // phoneNo: '',
  // mail: '',
  // address: {
  //   city: '',
  //   area: '',
  //   zip: '',
  //   road: ''
  // }
};

export const model = {
  name: {
    firstName: '',
    lastName: ''
  },
  dateOfBirth: {
    year: '',
    month: '',
    day: '',
  },
  identityNo: '',
  phoneNo: '',
  mail: '',
  address: {
    city: '',
    area: '',
    zip: '',
    road: ''
  },
  homeAddress: {
    city: '',
    area: '',
    zip: '',
    road: ''
  },
  RefAgent:'',
  reviewMail: ''
};

export const rules = {
  name,
  dateOfBirth,
  identityNo,
  phoneNo,
  mail,
  address
};

export const updateRules = { ...rules, password };